import React from "react";
import { MapPin, Camera, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheLoneExplorersView() {
  return <section data-section-id="2858" id="the-moondos-vision" className="dark relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <style>{`
        
        :root {
          --secondary: HSL(0 0% 50%); 
          --ring: HSL(0 0% 50%); 
          --chart-1: HSL(0 0% 50%); 
          --chart-4: HSL(0 0% 50%); 
          --sidebar-ring: HSL(0 0% 50%); 
        }
        .dark {
          --secondary: HSL(0 0% 50%); 
          --ring: HSL(0 0% 50%); 
          --chart-1: HSL(0 0% 50%); 
          --chart-4: HSL(0 0% 50%); 
          --sidebar-ring: HSL(0 0% 50%); 
        }
        @keyframes subtleZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }
        @keyframes scrollLine {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(100%); opacity: 0; }
        }
        .animate-subtle-zoom {
          animation: subtleZoom 20s ease-in-out infinite alternate;
        }
        .animate-scroll-line {
          animation: scrollLine 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline className="h-full w-full object-cover animate-subtle-zoom opacity-40">
          <source src="/video/hero.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-transparent to-black/90" />
        <div className="absolute inset-0 bg-background/40 mix-blend-multiply" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        {}
        <img src="https://rich-pup.10web.cloud/wp-content/uploads/2026/03/moondos-media.png" alt="Moondos Media logo" className="h-32 sm:h-48 md:h-64 object-contain drop-shadow-2xl" />

        {}
        <div className="mt-8 mb-10 flex flex-wrap items-center justify-center gap-4 rounded-sm border border-white/10 bg-white/5 px-6 py-2 text-xs font-medium tracking-widest text-white/80 backdrop-blur-md md:text-sm">
          <div className="flex items-center gap-2">
            <span className="font-mono uppercase">Digital Architects</span>
          </div>
          <div className="h-3 w-px bg-white/20" />
          <div className="flex items-center gap-2">
            <span className="font-mono uppercase">Strategic Branding</span>
          </div>
        </div>

        {}
        <Link to="/StartYourProjectPage">
          <Button size="lg" className="group relative overflow-hidden border-none bg-white text-black transition-all duration-500 hover:scale-105 hover:text-white rounded-sm">
            <span className="relative z-10 font-mono font-bold tracking-tight uppercase">Start a Project</span>
            <div className="absolute inset-0 -z-0 translate-y-full bg-gradient-to-r from-secondary to-indigo-600 transition-transform duration-500 group-hover:translate-y-0 !bg-[url(https://rich-pup.10web.cloud/wp-content/uploads/2026/03/moondos-media.png)]" />
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.4em] text-white/40">
          Explore
        </span>
        <div className="h-12 w-px overflow-hidden bg-white/10">
          <div className="h-full w-full bg-secondary animate-scroll-line" />
        </div>
      </div>
    </section>;
}